/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_SummaryInputs */

const en_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage Summary`)
};

const es_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de uso`)
};

const fr_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résumé de l'utilisation`)
};

const de_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsübersicht`)
};

const ja_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用状況の概要`)
};

const zh_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用情况汇总`)
};

const ar_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملخص الاستخدام`)
};

const id_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan Penggunaan`)
};

const it_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo Utilizzo`)
};

const ru_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сводка использования`)
};

const pt_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo de Uso`)
};

const ko_usage_summary = /** @type {(inputs: Usage_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용 요약`)
};

/**
* | output |
* | --- |
* | "Usage Summary" |
*
* @param {Usage_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const usage_summary = /** @type {((inputs?: Usage_SummaryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_SummaryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_usage_summary(inputs)
	if (locale === "es") return es_usage_summary(inputs)
	if (locale === "fr") return fr_usage_summary(inputs)
	if (locale === "de") return de_usage_summary(inputs)
	if (locale === "ja") return ja_usage_summary(inputs)
	if (locale === "zh") return zh_usage_summary(inputs)
	if (locale === "ar") return ar_usage_summary(inputs)
	if (locale === "id") return id_usage_summary(inputs)
	if (locale === "it") return it_usage_summary(inputs)
	if (locale === "ru") return ru_usage_summary(inputs)
	if (locale === "pt") return pt_usage_summary(inputs)
	return ko_usage_summary(inputs)
});